<!--
// app/components/Shared/CardNoDataMessage.vue
-->
<script setup lang="ts">
type Props = {
  message: string | undefined;
};
defineProps<Props>();
</script>

<template>
  <div class="bg-gray-800 rounded-lg p-6 w-full max-h-40">
    <p>{{ message }}</p>
  </div>
</template>

<style scoped></style>
